import * as z from "zod";
import { checkoutChrome } from "../checkout-chrome";

export const getCheckoutChromeInput = z.object({});

export const getCheckoutChromeOutput = z.object({
  // Null when branding is unavailable (no scope, none published, fetch
  // failed); the app renders its built-in Shopify-default chrome.
  chrome: checkoutChrome.nullable(),
  // Storefront header links, derived from the team (not branding) and always
  // populated so the fallback state still links, as Shopify's checkout does.
  storefrontUrl: z.string().url(),
  cartUrl: z.string().url(),
});
